import uniqueIdGenerator from '@src/utils/uniqueIdGenerator'

import { ANALYTIC_COOKIES } from './constants'
import getCookie from './getCookie'
import isBrowser from './isBrowser'
import setCookie from './setCookie'
// import { setInLocalStorageWithExpiry } from './setInLocalStorageWithExpiry'

export const getlbUserId = () => {
  if (!isBrowser()) return
  return getCookie(ANALYTIC_COOKIES.LB_USER_ID_SERVER) ?? getCookie(ANALYTIC_COOKIES.LB_USER_ID) ?? ''
}

export function createLastBrandUserId() {
  // eslint-disable-next-line i18next/no-literal-string
  const lbUserId = uniqueIdGenerator('c-')
  const isSecure = isBrowser() ? window.location.protocol === 'https:' : true
  setCookie(ANALYTIC_COOKIES.LB_USER_ID, lbUserId, 400 * 24 * 60, isSecure, false)
  setCookie(ANALYTIC_COOKIES.LB_USER_FIRST_ACCESS, isSecure, 1)
}

// NOTE: algolia does not support colons in the user id. For backward compatibility,
// we are replacing colons with hyphen for search API calls and algolia search events.
export const getLbUserIdWithoutColons = () => {
  return getlbUserId()?.replace(/:/g, '-') ?? ''
}
